import { cn } from "@/lib/cn";
import type { SelectHTMLAttributes } from "react";

type NativeSelectProps = SelectHTMLAttributes<HTMLSelectElement>;

/** Styled native <select>. Matches the Input look (h-10, rounded-lg, tokened focus). */
export function NativeSelect({ className, children, ...props }: NativeSelectProps) {
  return (
    <select
      className={cn(
        "h-10 w-full rounded-lg border border-[var(--color-border)] bg-white px-3 text-base sm:text-sm text-[var(--color-text)] outline-none transition-colors focus:border-[var(--color-accent)] focus:ring-2 focus:ring-[var(--color-accent)]/15 disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
    </select>
  );
}
